export type GrantFitTier = "strong" | "possible" | "low";

export function grantFitTierLabel(tier: GrantFitTier): string {
  switch (tier) {
    case "strong":
      return "Strong match";
    case "possible":
      return "Possible fit";
    case "low":
      return "Low fit";
    default:
      return "Fit unknown";
  }
}

export function grantFitTierClass(tier: GrantFitTier): string {
  switch (tier) {
    case "strong":
      return "bg-emerald-100 text-emerald-800 dark:bg-emerald-950/50 dark:text-emerald-200";
    case "possible":
      return "bg-blue-100 text-blue-800 dark:bg-blue-950/50 dark:text-blue-200";
    case "low":
      return "bg-muted text-muted-foreground";
    default:
      return "bg-muted text-muted-foreground";
  }
}

export function grantFitTierDotClass(tier: GrantFitTier): string {
  switch (tier) {
    case "strong":
      return "bg-emerald-500";
    case "possible":
      return "bg-blue-500";
    case "low":
      return "bg-muted-foreground/50";
    default:
      return "bg-muted-foreground/50";
  }
}

export const PRIORITY_AREA_LABELS: Record<string, string> = {
  housing: "Housing",
  infrastructure: "Infrastructure",
  public_safety: "Public safety",
  economic_development: "Economic development",
  environment: "Environment",
  health_human_services: "Health & human services",
  education: "Education",
  transportation: "Transportation",
  parks_recreation: "Parks & recreation",
  broadband: "Broadband",
  emergency_management: "Emergency management",
};

export const ENTITY_TYPE_OPTIONS = [
  { value: "city", label: "City government" },
  { value: "county", label: "County government" },
  { value: "state", label: "State government" },
  { value: "special_district", label: "Special district" },
  { value: "nonprofit_partner", label: "Nonprofit partner" },
] as const;

export const PROJECT_SIZE_OPTIONS = [
  { value: "unknown", label: "Not sure" },
  { value: "under_100k", label: "Under $100k" },
  { value: "from_100k_to_1m", label: "$100k – $1M" },
  { value: "over_1m", label: "Over $1M" },
] as const;
